import type { ReactElement } from "react";
import React from "react";

export const ArrowBackIcon = ({ className = "" }: { className?: string }): ReactElement => {
  return (
    <svg
      className={className}
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_522_5603" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_522_5603)">
        <path
          d="M10.4974 17.4666L18.0256 24.9949L15.9666 27.0666L4.93335 16.0333L16.0333 4.93335L18.0922 7.00512L10.4974 14.6H27.0666V17.4666H10.4974Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
